import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-personal-offer-status',
  templateUrl: './personal-offer-status.component.html',
  styleUrls: ['./personal-offer-status.component.scss'],
  standalone: true,
})
export class PersonalOfferStatusComponent {
  @Input() status!: string;
  
  public statusesMapping: { [key: string]: string} = {
    'ACTIVE': 'Очікує підтвердження',
    'ACCEPTED': 'Прийнято',
    'REJECTED': 'Відхилено',
    'CANCELLED': 'Скасовано',
    'EXPIRED': 'Протерміновано',
  }
  
  public colorsMapping: { [key: string]: string} = {
    'ACTIVE': '#FFBD12',
    'ACCEPTED': '#00C95C',
    'PARTIALLY_COMPLETE': '#00C95C',
    'REJECTED': '#FC5C5C',
    'CANCELLED': '#FC5C5C',
    'EXPIRED': '#FC5C5C',
  }
  
}
